import { createFileRoute, redirect } from '@tanstack/react-router';
import { formatPairingCode } from '../pairingCode';

/** @deprecated Prefer `/connect` — kept for CLI links that still open `/device`. */
export const Route = createFileRoute('/device')({
  validateSearch: (search: Record<string, unknown>): { code?: string } => ({
    code:
      typeof search.code === 'string' && search.code ? formatPairingCode(search.code) : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/connect',
      search: search.code ? { code: search.code } : {},
    });
  },
});
